import  API_URL from '../../constants/API_URL.js';
import { clientById } from './getClientByIdAction'
import { message } from 'antd'
import axios from 'axios'
export const LOGIN_IN_PROGRESSA = 'LOGIN_IN_PROGRESSA';
export const LOGIN_FAILEDA = 'LOGIN_FAILEDA';
export const LOGIN_SUCCESSFULA = 'LOGIN_SUCCESSFULA';
export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL';

const loginSuccessfulActionA = data => ({
	type: LOGIN_SUCCESSFULA,
	data,
});
const loginSuccessfulAction = data => ({
	type: LOGIN_SUCCESSFUL,
	data,
});

const loginFailedActionA = data => ({
	type: LOGIN_FAILEDA,
	data,
});
const getClientTaxId = (token) => {
   
  var authOptions = {
    method: 'GET',
    url: API_URL + 'clientByID',
    params: {
      clientId: token.clientId,
      lang: token.lang
    },
    headers: {
      'Authorization': token.tokenType + ' ' + token.accessToken,
      'Content-Type': 'application/json'
    }
  }
  axios(authOptions)
  .then(function (response) {
    if(response.data.object && response.data.object.tax){
      localStorage.setItem("taxId",response.data.object.tax);
    }

  })
}
const saveCLientTaxInLocalStorage = (client, tokenType, accessToken) => {
  let authOptions = {
    method: 'GET',
    url: API_URL + 'clientByID',
    params: {
      clientId: client,
      lang: localStorage.getItem("lang")
    },
    headers: {
      'Authorization': tokenType + ' ' + accessToken,
      'Content-Type': 'application/json'
    }
  }
  axios(authOptions)
    .then(res => {
      if(res.data.success && res.data.object && res.data.object.taxNo){
        localStorage.setItem('taxNo', res.data.object.taxNo)
      }else{
        localStorage.setItem('taxNo', '')
      }
    })
}
export const loginThunka =(body) => (dispatch)=>{
  dispatch({type:LOGIN_IN_PROGRESSA});
  const authOptions = {method:'POST',url:API_URL+'auth/posSignin',data:body}  
  axios(authOptions)
    .then( (response) => {
      getClientTaxId({
        tokenType: response.data.tokenType,
        accessToken: response.data.accessToken,
        clientId:response.data.clientId,
        lang: "END_DATE"
      })
      if(typeof(response.data) == 'string' ){
        message.error(response.data)
      }else{
        // console.log(response)
        localStorage.setItem("accessToken",response.data.accessToken);
        localStorage.setItem("tokenType",response.data.tokenType)
        localStorage.setItem("clientId",response.data.clientId);
        localStorage.setItem("clientName",response.data.name);
        localStorage.setItem('userData',JSON.stringify(response.data))
        localStorage.setItem("isInclusiveTax",response.data.isInclusiveTax);
        localStorage.setItem("posOnlyUserLogin", true)
        localStorage.setItem('posLogin','true')
        localStorage.setItem("orderType",response.data.orderType);
        dispatch(clientById(response.data.clientId,response.data.clientlogo,response.data.logoContentType))
        saveCLientTaxInLocalStorage(response.data.clientId, response.data.tokenType, response.data.accessToken)
        dispatch(loginSuccessfulActionA( response.data));
        dispatch(loginSuccessfulAction( response.data));
      }
        })
        .catch( (err) => {
          message.error(JSON.parse(JSON.stringify(err)).response.data.message)
        dispatch(loginFailedActionA(err))
      });

}

